<template>
  <div class="d-flex flex-wrap align-center justify-space-between">
    <div class="flex-1">
      <v-text-field
        v-model="value.search"
        placeholder="Search assets and products"
        prepend-inner-icon="mdi-magnify"
        type="text"
        outlined
        class="c-input short search-box"
        hide-details
      ></v-text-field>
    </div>
    <div class="d-flex align-center flex-wrap">
      <v-divider
        vertical
        class="mx-5 border-color-primary opacity-2 d-none d-lg-flex"
      ></v-divider>
      <div class="d-flex align-center flex-wrap mt-3 mt-lg-0">
        <div class="d-flex align-center justify-space-between flex-2">
          <div class="gray--text text-6 font-weight-medium">Filter:</div>
          <div
            :class="[
              'btn-badge text-6 font-weight-medium ml-0 ml-sm-4',
              { active: value.productType === '' },
            ]"
            @click="updateFilter(['productType', 'ecosystem', 'legacy'], ['', '', false])"
          >
            All
          </div>
          <v-divider
            vertical
            class="ml-4 border-color-primary opacity-2"
          ></v-divider>
          <div
            v-for="pt in productTypes"
            :key="pt.value"
            :class="[
              'btn-badge text-6 font-weight-medium ml-0 ml-sm-4',
              { active: value.productType === pt.value },
            ]"
            @click="updateFilter('productType', pt.value)"
          >
            {{ pt.text }}
          </div>
        </div>
        <div
          class="d-flex align-center justify-space-between flex-1 mt-2 mt-sm-0"
        >
          <v-divider
            vertical
            class="ml-4 border-color-primary opacity-2 d-none d-sm-flex"
          ></v-divider>
          <div
            v-for="ec in ecosystems"
            :key="ec.name"
            :class="[
              'btn-badge text-6 font-weight-medium ml-0 ml-sm-4 text-uppercase',
              { active: value.ecosystem === ec.name },
            ]"
            @click="updateFilter('ecosystem', ec.name)"
          >
            {{ ec.name }}
          </div>
        </div>
        <div
          class="d-flex align-center justify-space-between flex-1 mt-2 mt-sm-0"
        >
          <v-divider
            vertical
            class="ml-4 border-color-primary opacity-2 d-none d-sm-flex"
          ></v-divider>
          <div
            v-for="s in sorts"
            :key="s"
            :class="[
              'btn-badge text-6 font-weight-medium ml-0 ml-sm-4 text-uppercase',
              { active: value.sort === s },
            ]"
            @click="updateFilter('sort', s)"
          >
            {{ s }}
          </div>
          <v-divider
            vertical
            class="ml-4 border-color-primary opacity-2 d-none d-sm-flex"
          ></v-divider>
          <div
            :class="[
              'btn-badge text-6 font-weight-medium ml-0 ml-sm-4',
              { active: value.legacy },
            ]"
            @click="updateFilter(['legacy'], [!value.legacy])"
          >
            Legacy
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ecosystemsSimplified } from "@/common/config/ecosystems";

export default {
  props: {
    value: {
      search: String,
      productType: String,
      ecosystem: String,
      sort: String,
      legacy: {
        type: Boolean,
        default: false,
      }
    },
  },
  data: () => ({
    productTypes: [
      {
        value: "vaults",
        text: "DEFI",
      },
      {
        value: "stake",
        text: "PROOF-OF-STAKE",
      },
    ],
    ecosystems: ecosystemsSimplified,
    sorts: ["tvl", "apy", "product"],
  }),
  methods: {
    updateFilter(fields = [], values = []) {
      if (!Array.isArray(fields)) {
        fields = [fields];
      }
      if (!Array.isArray(values)) {
        values = [values];
      }
      const updated = fields.reduce(
        (acc, cur, index) => ({
          ...acc,
          [cur]: values[index],
        }),
        {}
      );
      this.$emit("input", {
        ...this.value,
        ...updated,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  min-width: 200px;
}
</style>
